<h2 mat-dialog-title>{{ 'CONFIRMATION' | translate }}</h2>

<mat-dialog-content>
    <p>{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button color="warn" (click)="onConfirm()">Confirmar</button>
    <button mat-button (click)="onCancel()">Cancelar</button>
</mat-dialog-actions>
